import { createContext, useContext, useEffect, useMemo, useState } from "react";
import Cookies from "js-cookie";
import { encryption, decryption } from "../auth/utilities";

const SubdomainContext = createContext({ subdomain: "", setSubdomain: () => {} });

const deriveInitialSubdomain = () => {
  const encrypted = Cookies.get("tenant");
  if (encrypted) {
    const decoded = decryption(encrypted);
    if (decoded) return decoded;
  }
  return "";
};

export const SubdomainProvider = ({ children }) => {
  const [subdomain, setSubdomain] = useState(deriveInitialSubdomain);

  useEffect(() => {
    if (subdomain) {
      Cookies.set("tenant", encryption(subdomain), { path: "/" });
    }
  }, [subdomain]);

  const value = useMemo(() => ({ subdomain, setSubdomain }), [subdomain]);

  return (
    <SubdomainContext.Provider value={value}>{children}</SubdomainContext.Provider>
  );
};

export const useSubdomain = () => useContext(SubdomainContext);

export const deriveSubdomainFromEmail = (email = "") => {
  const [localPart, domain] = email.split("@");
  if (!domain) return "";
  const normalized = domain.trim().toLowerCase();
  if (!normalized) return "";
  const label = normalized.split(".")[0];
  return label || "";
};
